var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n                            Ubah " + _vm._s(_vm.name) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('Ckeditor', {
    attrs: {
      "id": "deskripsi",
      "config": _vm.config
    },
    model: {
      value: (_vm.data.deskripsi),
      callback: function($$v) {
        _vm.$set(_vm.data, "deskripsi", $$v)
      },
      expression: "data.deskripsi"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [_c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "submit"
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Kirim")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal")])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "deskripsi"
    }
  }, [_vm._v("Deskripsi")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49de53d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Form.vue
// module id = t2fM
// module chunks = 1